export const getAssetHierarchyImage = (hierarchy, images) => {
  if (!hierarchy || images.length === 0) return null;
  const imageIds = hierarchy.filter(z => z.triggers.image && z.id).map(z => z.id);
  if (imageIds.length === 0) return null;

  return images[imageIds[0]] || null;
};

export const getAssetImage = (assetHierarchyId, images) => {
  if (!assetHierarchyId || images.length === 0) return null;
  return images[assetHierarchyId] || null;
};

export const getAssetTypeImage = (state, assetTypeId) => {
  const assetType = assetTypeId ? state.assetData.assetTypes?.find(x => x.assetTypeId === assetTypeId) : null;
  const assetTypeImage = state.assetData.assetTypes.isLoaded && assetType?.imageUrl;
  return assetTypeImage || null;
};

export const getAssetHierarchyId = hierarchy => {
  const ids = hierarchy.map(z => z.id);
  ids.sort((z, u) => u - z);
  return ids[0];
};

export const getIdenticalAssetConditions = params => {
  if (params.items.identicalAssetConditions) {
    try {
      const result = JSON.parse(params.items.identicalAssetConditions);
      return result;
    } catch {
      // Catch Json errors
    }
  }
  return [];
};

export const getAssetHierarchyData = state => {
  const { asset, hierarchy } = state.currentOffer.assetData.inEdit;
  const { document, validationInfo } = asset;

  let assetTypeId, hierarchyLevels, buildYearAndMonth;
  if (document) {
    assetTypeId = document.assetTypeId;
    hierarchyLevels = document.hierarchy;
    buildYearAndMonth = document.buildYearAndMonth;
  }

  return { assetTypeId, buildYearAndMonth, hierarchy, hierarchyLevels, validationInfo };
};
